import { z } from 'zod';
import { Cache, getApiInstance, harden } from '../core';

export const newsStoriesMediaSchema = z.object({
    url: z.string().nullable(),
});

export const newsStoriesArticleSchema = z.object({
    author: z.string().nullable(),
    title: z.string(),
    description: z.string().nullable(),
    url: z.string(),
    urlToImage: z.string().nullable(),
    publishedAt: z.string().nullable(),
    date: z.string().nullable(),
    media: z.array(newsStoriesMediaSchema),
    date_as_timestamp: z.number(),
    id_hash: z.string(),
    long_description: z.string().nullable(),
});

export const newsStoriesSourceSchema = z.object({
    status: z.string(),
    source: z.string().nullable(),
    sortBy: z.string().nullable(),
    articles: z.array(newsStoriesArticleSchema),
    updated: z.boolean().nullable(),
});

export const newsStoriesFeedSchema = z.object({
    sources: z.record(z.string(), newsStoriesSourceSchema),
    items: z.array(newsStoriesArticleSchema).default([]),
});

export const getNewsStoriesResponseSchema = z.object({
    status: z.literal('OK'),
    message: z.object({
        code: z.literal('NO_ERROR'),
    }),
    feed: newsStoriesFeedSchema,
});

export type NewsStoriesArticle = z.infer<typeof newsStoriesArticleSchema>;

export type NewStoriesResponse = z.infer<typeof getNewsStoriesResponseSchema>;

export async function getNewsStories(contentType: string): Promise<NewStoriesResponse> {
    const { api, cacheConfig } = await getApiInstance();
    const urlPath = `news/${contentType}`;

    cacheConfig(Cache.GetWithFallback, urlPath);

    const response = await api.get(urlPath);

    return harden(getNewsStoriesResponseSchema, response.data);
}
